import request from './request'

export function listPallet(data) {
  return request.post('/mes/pallets/list', data)
}
export function selectPallet(wareHouseId) {
  return request.get('/mes/pallets/select', { params: { wareHouseId } })
}
export function getPallet(id) {
  return request.get('/mes/pallets/' + id)
}
export function savePallet(data) {
  return request.post('/mes/pallets', data)
}
export function updatePallet(data) {
  return request.post('/mes/pallets/update', data)
}
export function deletePallet(ids) {
  return request.post('/mes/pallets/delete', ids)
}
